module.exports = __webpack_public_path__ + "img/verify.b91d1388.png";